import { createApp } from "vue";
import App from "./App.vue";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

import "./style/index.less";

import router from "./router/router";

import store from "./store/index";

import preventReClick from "./utils/preventReClick";

import Directives from "@/utils/clickOutSide.js";

// vue添加自定义数据
import { setMobileConfig } from "@/utils/get-client.js";
setMobileConfig();

const app = createApp(App);

app.use(router);

app.use(store);

app.use(ElementPlus);

app.use(VideoPlayer);

app.use(preventReClick);

app.use(Directives);

app.mount("#app");
